import request from '@/config/axios'

export const getPrizeList = () => request.get({ url: '/rental/lottery/prize/list' })

export const savePrize = (data: {
  id?: number
  name: string
  prizeType: string
  prizeValue?: string
  weight?: number
  status?: number
}) => request.post({ url: '/rental/lottery/prize/save', data })

export const deletePrize = (id: number) =>
  request.delete({ url: '/rental/lottery/prize/delete', params: { id } })
